import { AuthHeader, AuthLayout, Skeleton, Tabs } from "@nabble/ui";
import { Link } from "react-router-dom";
import { MfaMethodForm } from "./MfaMethodForm";
import { METHOD_TAB, type MfaMethod } from "./mfaMethods";
import { useMfaMethods } from "./useMfaMethods";
import { useMfaVerification } from "./useMfaVerification";

export default function MfaPage(): React.JSX.Element {
  const { methods, selected, select, loadError } = useMfaMethods();
  const verification = useMfaVerification();

  return (
    <AuthLayout step={{ current: 2, total: 2, label: "verification" }}>
      <AuthHeader title="Two-step verification" lead="Confirm it's you to finish signing in." />
      <div className="nb-auth-content">
        {methods === null ? (
          <div className="nb-stack">
            <Skeleton height={36} radius={10} />
            <Skeleton height={52} radius={10} />
            <Skeleton height={46} radius={10} />
          </div>
        ) : (
          <>
            {methods.length > 1 ? (
              <Tabs
                block
                ariaLabel="Verification method"
                items={methods.map((m) => ({ id: m, label: METHOD_TAB[m].label, icon: METHOD_TAB[m].icon }))}
                value={selected ?? undefined}
                onChange={(id) => {
                  select(id as MfaMethod);
                  verification.clearError();
                }}
              />
            ) : null}

            <MfaMethodForm method={selected} verification={verification} loadError={loadError} />
          </>
        )}
      </div>
      <div className="nb-auth-foot">
        <Link to="/login" className="nb-auth-back">
          Use another account
        </Link>
      </div>
    </AuthLayout>
  );
}
